import { motion } from 'framer-motion';
import { useState } from 'react';

const galleryImages = [
  {
    src: 'https://static.wixstatic.com/media/35bb17_4f5415cdea194bcfa7c657262b5f3718~mv2.jpg/v1/fill/w_568,h_368,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/35bb17_4f5415cdea194bcfa7c657262b5f3718~mv2.jpg',
    category: 'Hail Damage',
    description: 'Complete hail damage restoration',
  },
  {
    src: 'https://static.wixstatic.com/media/35bb17_a494a0e79cbd483cb265c30ab7578612~mv2.jpg/v1/fill/w_568,h_368,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/35bb17_a494a0e79cbd483cb265c30ab7578612~mv2.jpg',
    category: 'Dent Repair',
    description: 'Door panel dent removal',
  },
  {
    src: 'https://static.wixstatic.com/media/35bb17_5f2e7e463af04dd9910513bee1e17527~mv2.jpg/v1/fill/w_568,h_368,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/35bb17_5f2e7e463af04dd9910513bee1e17527~mv2.jpg',
    category: 'Hail Damage',
    description: 'Hood hail damage repair',
  },
  {
    src: 'https://public.readdy.ai/ai/img_res/6a31289bf522c7c6289427268c38cbf7.jpg',
    category: 'Fleet',
    description: 'Commercial delivery van repair',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=row%20of%20white%20commercial%20cargo%20vans%20fleet%20vehicles%20parked%20in%20organized%20line%20clean%20industrial%20background%20professional%20business%20transportation%20vehicles%20side%20angle%20view%20bright%20natural%20lighting%20simple%20clean%20background&width=568&height=368&seq=fleet002&orientation=landscape',
    category: 'Fleet',
    description: 'Fleet vehicle maintenance',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=professional%20service%20truck%20with%20ladder%20rack%20and%20equipment%20white%20commercial%20work%20vehicle%20parked%20in%20clean%20lot%20fleet%20maintenance%20vehicle%20side%20view%20showing%20body%20panels%20bright%20daylight%20simple%20background%20professional%20automotive%20photography&width=568&height=368&seq=fleet003&orientation=landscape',
    category: 'Fleet',
    description: 'Service truck dent repair',
  },
  {
    src: 'https://static.wixstatic.com/media/35bb17_6ca177db251b4932ba2cd985d0f4be12~mv2.jpg/v1/fill/w_310,h_282,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/pierre-chatel-innocenti-Lk-nu_hX6ms-unsplash%202.jpg',
    category: 'Dent Repair',
    description: 'Precision dent removal',
  },
  {
    src: 'https://static.wixstatic.com/media/35bb17_f6a5abb7414e4674bc440c4e82ed8265~mv2.jpg/v1/fill/w_310,h_282,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/pierre-chatel-innocenti-Lk-nu_hX6ms-unsplash%202.jpg',
    category: 'Dent Repair',
    description: 'Side panel restoration',
  },
];

export default function Gallery() {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const categories = ['All', 'Hail Damage', 'Dent Repair', 'Fleet'];

  const filteredImages = selectedCategory === 'All' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedCategory);

  return (
    <section id="projects" className="py-24 bg-white">
      <div className="max-w-[1200px] mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="font-montserrat font-bold text-4xl md:text-5xl text-text-dark mb-4">
            View Our Work
          </h2>
          <p className="font-inter text-lg text-text-muted max-w-2xl mx-auto mb-8">
            See the quality of our paintless dent repair craftsmanship
          </p>

          {/* Category Filter */}
          <div className="flex flex-wrap items-center justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`font-montserrat font-medium px-6 py-2 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  selectedCategory === category
                    ? 'bg-primary text-white'
                    : 'bg-bg-soft text-text-dark hover:bg-secondary/10'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </motion.div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredImages.map((image, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-80 overflow-hidden">
                <img
                  src={image.src}
                  alt={image.description}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <span className="inline-block bg-primary text-white text-xs font-montserrat font-semibold px-3 py-1 rounded-full mb-2">
                      {image.category}
                    </span>
                    <h3 className="font-montserrat font-semibold text-white text-lg">
                      {image.description}
                    </h3>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-16 text-center"
        >
          <p className="font-inter text-lg text-text-muted mb-6">
            Ready to see these results on your vehicle?
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-primary hover:bg-[#e67028] text-white font-montserrat font-semibold px-8 py-4 rounded-full text-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Schedule Your Repair
          </button>
        </motion.div>
      </div>
    </section>
  );
}
